/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Hs_CodeInputs */

const en_attribute_hs_code = /** @type {(inputs: Attribute_Hs_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HS code`)
};

/**
* | output |
* | --- |
* | "HS code" |
*
* @param {Attribute_Hs_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_hs_code = /** @type {((inputs?: Attribute_Hs_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Hs_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_hs_code(inputs)
});